import React, { memo, useEffect, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';

import api from 'axios';
import { isEmpty } from 'lodash';
// import qs from 'querystring';

import { number, t } from '~/helpers';
import { getToastErrors } from '~/helpers/errorsRequest';

import * as S from './styles';

function SinoticoDescarregamentoPreset() {
  const [data, setData] = useState({});
  const token = useSelector((state) => state.auth);

  const handleGetDataPreset = useCallback(async ({ idPreset, idPosto }) => {
    try {
      const request = await api.get(
        `${process.env.REACT_APP_URL_REQUEST}descargasnfs/sinotico/detalhe/${idPreset}/${idPosto}`,
        {
          headers: {
            'Current-Route': window.location.pathname,
            Authorization: 'Bearer ' + `${token.token}`,
          },
        }
      );
      if (!isEmpty(request.data)) setData(request.data[0]);
    } catch (error) {
      getToastErrors(error);
    }
  }, []);

  useEffect(() => {
    const preset = localStorage.getItem('preset');
    const idposto = localStorage.getItem('idposto');
    handleGetDataPreset({ idPreset: preset, idPosto: idposto });
  }, []);

  useEffect(() => {
    const preset = localStorage.getItem('preset');
    const idposto = localStorage.getItem('idposto');

    const timeOut = setInterval(
      (preset, idposto) => {
        handleGetDataPreset({
          idPreset: preset,
          idPosto: idposto,
        });
      },
      15000,
      preset,
      idposto
    );

    return () => clearInterval(timeOut);
  }, []);

  if (data && data.listaPresetDados)
    return (
      <S.Wrapper>
        <S.WrapperHeader>
          <h2>{data.listaPresetDados[0].nomePreset}</h2>
        </S.WrapperHeader>
        <S.Infos>
          <li>
            <p>{t('s.operacao.recebimento.volume20nftbdescarganf')}:</p>
            <span>
              {number(
                data.listaPresetDados[0]?.listaDescargas[0]
                  ?.volume20Descarregado,
                0
              )}
            </span>
          </li>
          <li>
            <p>{t('s.operacao.recebimento.compartimentos.volumeambiente')}:</p>
            <span>
              {number(
                data.listaPresetDados[0]?.listaDescargas[0]
                  ?.volumeAmbienteDescarregado,
                0
              )}
            </span>
          </li>
          <li>
            <p>{t('s.global.vazao')}:</p>
            <span>
              {number(
                data.listaPresetDados[0]?.listaDescargas[0]?.vazaoInstantanea,
                0
              )}
            </span>
          </li>
        </S.Infos>

        <S.Progress
          full={data.listaPresetDados[0]?.listaDescargas[0]?.volumeProgramado}
          filled={
            data.listaPresetDados[0]?.listaDescargas[0]
              ?.volumeAmbienteDescarregado
          }
        />

        <div className="cardWrapper">
          <S.Programming>
            {t('s.menu.operacao.recebimento')}:
            <span>
              {data.listaPresetDados[0]?.listaDescargas[0]?.programacao}
            </span>
          </S.Programming>

          <S.Product>
            {data.listaPresetDados[0]?.listaDescargas[0]?.produto}
          </S.Product>

          <S.InfoProgramming>
            <li>
              {t('s.cadastro.veiculo.placaveiculo')}:
              <span>{data.listaPresetDados[0]?.listaDescargas[0]?.placa}</span>
            </li>
            <li>
              {t('s.global.volume')}:
              <span>
                {data.listaPresetDados[0]?.listaDescargas[0]?.volumeProgramado
                  ? number(
                      data.listaPresetDados[0]?.listaDescargas[0]
                        ?.volumeProgramado,
                      0
                    )
                  : 0}
              </span>
            </li>
          </S.InfoProgramming>
        </div>

        {data.listaPresetDados[0]?.listaDescargas[0]?.componentesCorrentes.map(
          (component) => (
            <S.Charging key={Math.random().toString()}>
              <li className="product__name">{component.produto}</li>
              <li>
                {t('s.geral.camposistema.encerranteinicialafericao')}:
                <span>{number(component.encerranteInicial, 0)}</span>
              </li>
              <li>
                {t('s.geral.camposistema.encerrantefinalafericao')}:
                <span>{number(component.encerranteFinal, 0)}</span>
              </li>
              {/* <li>
                {t('s.operacao.recebimento.compartimentos.volumeambiente')}:
                <span>{number(component.volumeAmbienteDescarregado, 0)}</span>
              </li>
              <li>
                {t('s.operacao.recebimento.volume20nftbdescarganf')}:
                <span>{number(component.volume20Descarregado, 0)}</span>
              </li> */}
              <li>
                {t('s.operacao.recebimentonf.skid.temperatura')}:
                <span>{number(component.temperatura, 1)}</span>
              </li>
              <li>
                {t('s.global.densidade')}:
                <span>{number(component.densidade, 4)}</span>
              </li>
              {/* <li>
                {t('s.global.vazao')}:<span>{number(component.vazao, 0)}</span>
              </li> */}
            </S.Charging>
          )
        )}
      </S.Wrapper>
    );

  return <div />;
}

export default memo(SinoticoDescarregamentoPreset);
